<template lang="pug">
    .wave-points
</template>

<script>
import * as THREE from 'three';
import WEBGL from './WEBGL';
export default {
    mounted () {

        /* eslint-disable */
        const vm = this;

        if ( WEBGL.isWebGLAvailable() === false ) {
            return;
        }
        var SEPARATION = 100, AMOUNTX = 50, AMOUNTY = 50;
        var container;
        var camera, scene, renderer;
        var particles, count = 0;
        var mouseX = 300, mouseY = -700;
        var windowHalfX = vm.$el.clientWidth / 2;
        var windowHalfY = vm.$el.clientHeight / 2;
        init();
        animate();
        function init() {
            container = vm.$el;
            camera = new THREE.PerspectiveCamera( 75, vm.$el.clientWidth / vm.$el.clientHeight, 1, 10000 );
            camera.position.z = 1000;
            scene = new THREE.Scene();
            //
            var numParticles = AMOUNTX * AMOUNTY;
            var positions = new Float32Array( numParticles * 3 );
            var scales = new Float32Array( numParticles );
            var i = 0, j = 0;
            for ( var ix = 0; ix < AMOUNTX; ix ++ ) {
                for ( var iy = 0; iy < AMOUNTY; iy ++ ) {
                    positions[ i ] = ix * SEPARATION - ( ( AMOUNTX * SEPARATION ) / 2 ); // x
                    positions[ i + 1 ] = 0; // y
                    positions[ i + 2 ] = iy * SEPARATION - ( ( AMOUNTY * SEPARATION ) / 2 ); // z
                    scales[ j ] = 1;
                    i += 3;
                    j ++;
                }
            }
            var geometry = new THREE.BufferGeometry();
            geometry.addAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );
            geometry.addAttribute( 'scale', new THREE.BufferAttribute( scales, 1 ) );
            var material = new THREE.ShaderMaterial( {
                uniforms: {
                    color: { value: new THREE.Color( 0x64729a ) },
                },
                vertexShader: `
attribute float scale;
void main() {
    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
    gl_PointSize = scale * ( 300.0 / - mvPosition.z );
    gl_Position = projectionMatrix * mvPosition;
}`,
                fragmentShader: `
uniform vec3 color;
void main() {
    if ( length( gl_PointCoord - vec2( 0.5, 0.5 ) ) > 0.475 ) discard;
    gl_FragColor = vec4( color, 1.0 );
}
                `
            } );
            //
            particles = new THREE.Points( geometry, material );
            scene.add( particles );
            //
            renderer = new THREE.WebGLRenderer( { antialias: true, alpha: true } );
            renderer.setClearColor(0xEEEEEE, 0.0);
            renderer.setPixelRatio( window.devicePixelRatio );
            renderer.setSize( vm.$el.clientWidth, vm.$el.clientHeight );
            container.appendChild( renderer.domElement );
            //
            window.addEventListener( 'resize', onWindowResize, false );
        }
        function onWindowResize() {
            windowHalfX = vm.$el.clientWidth / 2;
            windowHalfY = vm.$el.clientHeight / 2;
            camera.aspect = vm.$el.clientWidth / vm.$el.clientHeight;
            camera.updateProjectionMatrix();
            renderer.setSize( vm.$el.clientWidth, vm.$el.clientHeight );
        }
        this.onWindowResize = onWindowResize;

        //
        function animate() {
            vm.frameID = requestAnimationFrame( animate );
            render();
        }
        function render() {
            camera.position.x += ( mouseX - camera.position.x ) * .05;
            camera.position.y += ( - mouseY - camera.position.y ) * .05;
            camera.lookAt( scene.position );
            var positions = particles.geometry.attributes.position.array;
            var scales = particles.geometry.attributes.scale.array;
            var i = 0, j = 0;
            for ( var ix = 0; ix < AMOUNTX; ix ++ ) {
                for ( var iy = 0; iy < AMOUNTY; iy ++ ) {
                    positions[ i + 1 ] = ( Math.sin( ( ix + count ) * 0.3 ) * 50 ) +
                                    ( Math.sin( ( iy + count ) * 0.5 ) * 50 );
                    scales[ j ] = ( Math.sin( ( ix + count ) * 0.3 ) + 1 ) * 8 +
                                    ( Math.sin( ( iy + count ) * 0.5 ) + 1 ) * 8;
                    i += 3;
                    j ++;
                }
            }
            particles.geometry.attributes.position.needsUpdate = true;
            particles.geometry.attributes.scale.needsUpdate = true;
            renderer.render( scene, camera );
            count += 0.1;
        }

        /* eslint-enable */
    },
    beforeDestroy () {
        cancelAnimationFrame(this.frameId);
        window.removeEventListener('resize', this.onWindowResize);
    },
};
</script>

<style lang="sass">
    .wave-pointes
        overflow: hidden
</style>